<template>
  <input class="search-input__input" v-bind="$attrs" v-on="$listeners" />
</template>

<script lang="ts">
export default {
  name: "SearchInput",
};
</script>

<style scoped lang="scss">
.search-input__input {
  width: 100%;
  max-width: 580px;
  height: 50px;
  background: url("/img/components/icons/search.svg") no-repeat scroll 15px center;
  background-size: 24px 24px;
  padding-left: 55px;
  padding-top: 8px;
  font-size: 16px;
  font-weight: 400;
  color: $color-iloq-gray-dark;
  border: 1px solid $color-iloq-gray-light;
  border-radius: 7px;
  box-shadow: 0 1px 4px 0 darken($color-iloq-gray-light, 20%);

  &:focus {
    outline: none;
  }

  ::placeholder {
    color: $color-iloq-gray;
    opacity: 1;
    font-style: italic;
  }
}
</style>
